// extracted by mini-css-extract-plugin
module.exports = {"entity":"_2KIT0p0y","header":"_3Brto3UV","title":"_1nJoOD6V"};